module.exports = {"370827001":"谷亭街道","370827002":"滨湖街道","370827101":"清河镇","370827102":"鱼城镇","370827103":"王鲁镇","370827104":"张黄镇","370827105":"王庙镇","370827106":"李阁镇","370827107":"唐马镇","370827108":"老砦镇","370827109":"罗屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370827.json
// module id = 1428
// module chunks = 0